import {
    AfterViewInit,
    Component,
    ElementRef,
    InputSignal,
    Signal,
    ViewChild,
    WritableSignal,
    computed,
    input,
    signal,
    effect
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IqTrendlinesGraphLtNtlStateService } from '../state';
import { Ratio } from '../models';
import { isNil } from 'lodash';

@Component({
    selector: 'iq-trendlines-graph-lt-ntl-flatbed',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-trendlines-graph-lt-ntl-flatbed.component.html',
    styleUrl: './iq-trendlines-graph-lt-ntl-flatbed.component.scss',
})
export class IqTrendlinesGraphLtNtlFlatbedComponent{
    id: InputSignal<string> = input('');
    testId: InputSignal<string> = input('');

    currentTestId: Signal<string> = computed(() => {
        return !!this.testId()?.length ? this.testId() : this.id();
    });

    @ViewChild('graph') container: ElementRef;

    data: WritableSignal<Ratio[]> = signal(null);

    constructor(private _state: IqTrendlinesGraphLtNtlStateService) {
        this._state.flatbedData().then((data) => {
            this.data.set(data);
        });

        effect(() => {
            if (!isNil(this.data())) {
                this._state.flatbedGraph(this.container, this.data());
            }
        });
    }
}
